/**
 * @file Created on Wed Aug 08 2018
 * @author PKl
 */
import withValidation from './withValidation';
export default withValidation;